import { useChargement, type Chargeable } from "@/lib/chargement";
import { api, type Referentiel } from "@/lib/api";

/**
 * Un référentiel administrable, lu depuis l'API (ADR-0030).
 *
 * Les valeurs vivent en base et se règlent depuis l'écran d'administration ;
 * aucune n'est écrite ici. Le formulaire ne propose que les valeurs ACTIVES ;
 * l'administration les voit toutes, désactivées comprises.
 */
export function useReferentiel(
  nom: string,
  { actives = false }: { actives?: boolean } = {},
): Chargeable<Referentiel> {
  return useChargement<Referentiel>((signal) => api.referentiel(nom, actives, signal), [
    nom,
    actives,
  ]);
}
